import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';

import {Observable} from 'rxjs/Rx';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


@Injectable()
export class AppEnvironmentService {

  private headers;
  options;
  token: any;
  
  constructor(private _httpService: Http) { 
    
  

  }

  getAppEnvironment(): Observable<string> {
    let url = `/api/appenvironment`;
       return this._httpService.get(url)
       .map(res => res.text())
       .catch(error => Observable.throw(error || 'Server error'));
    
  }



   private handleError(error: any): Promise<any> {
    console.error('DEU ERRO!', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/services/app-environment.service.ts